import companyInfo from '../../themes/themes';

const THEME = process.env.REACT_APP_THEME;
const COMPANY = companyInfo[THEME].company;

const messages = {
  CBB: {
    storeUrlSubtitle: ``,
    noStore: `Currently, ${COMPANY} only provides financing to
        existing online stores. Please set up your store with a service of your
        choice, and return to your account (we’ll save your spot!).`,
    noProduct: `Currently, ${COMPANY} only provides financing for products with a
    sales history.`,
    lineExplainedWeProvideText: `${COMPANY} Growth Plan provides financing for your eCommerce store based on the supply chain Lines you have built. Ready to build your first Line?`,
    stockOnHandTextBelow:
      'Sharing your estimated sales periods helps us provide you with a more accurate and convenient Growth Plan.',
    signupHeader: 'Congratulations!',
    signupSubHeader: `You're on your way to becoming an ${COMPANY} seller. Create an account to continue your journey.`,
    explanations: {
      explanation_1:
        'Our planning tool helps you visualize your supply chain in real-time',
      explanation_2:
        'Build supply chain Lines for each product you want to fund',
      explanation_3: `We'll create a custom Growth Plan for you, complete with continuous capital for every stage in your supply chain.`,
    },
  },
  '8DATA': {
    storeUrlSubtitle: `URL should consist of shop name and myshopify.com suffix e.g. 'https://my-shop-name.myshopify.com'`,
    noStore: `Currently, ${COMPANY} only provides a supply chain planning and analytics tool to existing online stores. Please set up your Shopify store, and return to your ${COMPANY} account (we'll save your spot!).`,
    noProduct: `Currently, ${COMPANY} requires products with a sales history.`,
    lineExplainedWeProvideText: `Ready to build your first Line?`,
    stockOnHandTextBelow: '',
    signupHeader: 'Welcome!',
    signupSubHeader:
      'You are on your way to unleash your store potential. Create an account to continue your journey.',
    explanations: {
      explanation_1: 'Visualize your supply chain in real-time',
      explanation_2: 'Optimize your sales & COGS with useful metrics',
      explanation_3: 'Align your supply chain with your sales velocity',
    },
  },
};

export const NO_STORE = messages[THEME].noStore;
export const NO_PRODUCT = messages[THEME].noProduct;
export const LINE_EXPLAINED_WE_PROVIDE =
  messages[THEME].lineExplainedWeProvideText;
export const STOCK_ON_HAND_TEXT_BELOW = messages[THEME].stockOnHandTextBelow;
export const SIGNUP_HEADER = messages[THEME].signupHeader;
export const SIGNUP_SUB_HEADER = messages[THEME].signupSubHeader;
export const STORE_URL_SUBTITLE = messages[THEME].storeUrlSubtitle;
export const EXPLANATIONS: {
  explanation_1: string;
  explanation_2: string;
  explanation_3: string;
} = messages[THEME].explanations;
